import { render, staticRenderFns } from "./work-order-notes.html?vue&type=template&id=53a2ca2a&scoped=true&"
import script from "./work-order-notes.js?vue&type=script&lang=js&"
export * from "./work-order-notes.js?vue&type=script&lang=js&"
import style0 from "./WorkOrderNotes.vue?vue&type=style&index=0&id=53a2ca2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a2ca2a",
  null
  
)

export default component.exports